module.exports = __webpack_public_path__ + "static/1-4-brochure-pdf-eee8a9c3c8db1e9f422a23db799bd292.pdf";